import React from "react";
import { Flex, Typography } from "antd";
import SubFieldItem from "./SubFieldItem";

const FieldList = ({ fields, values }) => (
  <Flex vertical gap={12}>
    {fields.map((f) => (
      <Flex key={f.id} vertical gap={4}>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {f.label || "Untitled"}
        </Typography.Text>
        <SubFieldItem field={f} values={values} showLabel={false} />
      </Flex>
    ))}
  </Flex>
);

export default FieldList;
